export default __webpack_public_path__ + "static/media/mod02.8a77c317.svg";